import React, { useState } from "react";
import { Icon } from "@vds/icons";

/**
 * MovableToolbar: A vertical toolbar (36px wide) with evenly spaced children and a close icon.
 * When closed, only the close icon is shown. Clicking it toggles open/close.
 * Usage: Place children inside <MovableToolbar>...</MovableToolbar>
 */

const sideBarStyle = {
    background: '#fff',
    borderRadius: '16px 16px 0 0',
    // Only left and bottom shadow, with depth effect
    boxShadow: '4px 8px 16px rgba(0,0,0,0.15), -2px 0 8px rgba(0,0,0,0.07)',
    backgroundColor: '#fff',
    cursor: 'pointer',
    padding: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'box-shadow 0.2s',
}

const MovableToolbar = ({ children, style }) => {
    const [open, setOpen] = useState(true);

    return (
        <div>
            <div
                style={{
                    position: "absolute",
                    top: -3,
                    width: 10,
                    right:20,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: open ? "space-between" : "center",
                    height: "100%", // adjust height as needed
                    background: "rgb(255 253 253 / 0%)",
                    borderRadius: 8,
                    ...style,
                }}
            >
                {/* Close/Open icon at the top */}
                {/* <div
                    className="movable-sidebar-div-location"
                    style={{ ...sideBarStyle, borderRadius: '8px 8px 8px 8px' }}
                    onClick={() => setOpen((v) => !v)}
                >
                    <Icon name={open ? "close" : "plus"} size="small" color="#000" />
                </div> */}

                {/* Only show children if open */}
                {open && (
                    <div
                        style={{
                            flex: 1,
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 0,
                        }}
                    >
                        {children}
                    </div>
                )}
            </div>
        </div>
    );
};

export default MovableToolbar;